<nb-card class="view-log-dialog">
	<nb-card-header>
		<div class="row">
			<div class="col">
				{{ data?.title || ('DIALOG.ALERT' | translate) }}
			</div>
			<button
				class="col-auto"
				nbButton
				ghost
				(click)="close()"
				type="button"
			>
				<nb-icon icon="close-outline"></nb-icon>
			</button>
		</div>
	</nb-card-header>
	<nb-card-body class="custom-scroll">
		{{ data?.message }}
	</nb-card-body>
	<nb-card-footer>
		<button class="mr-2" nbButton status="primary" (click)="close()">
			{{ data?.closeText || ('BUTTONS.OK' | translate) }}
		</button>
	</nb-card-footer>
</nb-card>
